<div class="container">
  <div class="row row-with-bottom-padding">
    <div class="col-md-12">

      <div class="auth-box">

        <div class="logo-above-auth-box logo-tenant-as-background"></div>

         <!-- content -->
         <div class="auth-box-content-wrapper">

          <div class="alert alert-success" *ngIf="working">
            <p>
              {{ 'activate.activating' | translate }}<br/>
              {{ 'activate.takes-moment' | translate }}
            </p>
          </div>

          <app-form-error [error]="error"></app-form-error>

          <div *ngIf="!working && success" class="alert alert-success">
              <div class="done">
                  <i class="glyphicon glyphicon-ok"></i>
              </div>
              <h4>{{ 'activate.account-ready' | translate }}</h4>
              <p>
                {{ 'activate.account-activated' | translate }}
              </p>
              <button class="btn btn-info" routerLink="/login">
                {{ 'activate.to-login' | translate }}
              </button>
            </div>

            </div>
        </div>
      </div>
    </div>
  </div>
